import { render } from "./ed-organism-dashboard-navigation.vue?vue&type=template&id=e96fe944&scoped=true"
import script from "./ed-organism-dashboard-navigation.vue?vue&type=script&lang=js"
export * from "./ed-organism-dashboard-navigation.vue?vue&type=script&lang=js"

import "./ed-organism-dashboard-navigation.vue?vue&type=style&index=0&id=e96fe944&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96fe944"]])

export default __exports__